/** Libraries */
import React, { useEffect, useState } from "react";
import { Layer, Line, Stage } from "react-konva";
import useResizeObserver from "use-resize-observer";
import { SigStage } from "./shared-styled-components";
import { colorBrandRhumbixBlack } from "@rhumbix/rmbx_design_system_design_tokens";
const signatureStyles = {
    strokeWidth: 5,
    lineTension: 0.5,
};
export const DrawToSign = (props) => {
    const { stageHeight, signatureBox, lines, setLines, addSig } = props;
    // this tracks if the user resizes the window and adjusts the width
    const { ref: wrapperRef, width } = useResizeObserver();
    const [isDrawing, setIsDrawing] = useState(false);
    const [stageWidth, setStageWidth] = useState(width);
    const [stageScale, setStageScale] = useState(1);
    const [origWidth, setOrigWidth] = useState(width);
    useEffect(() => {
        // we only want to scale signatures down if the user scales down the window
        // we don't want signatures that started in a small window to scale off the stage if they expand
        const newScale = Math.min(origWidth && width ? width / origWidth : 1, 1);
        setStageScale(newScale);
        setStageWidth(width);
        if (!origWidth) {
            setOrigWidth(width);
        }
    }, [width]);
    useEffect(() => {
        // if the user clears the signature, also reset the stage and scale
        if (lines.length === 0) {
            setStageWidth(width);
            setOrigWidth(width);
            setStageScale(1);
        }
    }, [lines]);
    const handleMouseDown = (e) => {
        setIsDrawing(true);
        const pos = e.target.getStage()?.getPointerPosition();
        if (lines)
            setLines([...lines, { points: [pos?.x, pos?.y] }]);
    };
    const handleMouseMove = (e) => {
        // no drawing - skipping
        if (!isDrawing) {
            return;
        }
        const point = e.target.getStage()?.getPointerPosition();
        const lastLine = lines?.[lines.length - 1];
        // add point
        if (lastLine)
            lastLine.points = lastLine.points.concat([point?.x, point?.y]);
        // replace last
        lines?.splice(lines.length - 1, 1, lastLine);
        setLines(lines?.concat());
    };
    const handleMouseUp = () => {
        setIsDrawing(false);
        addSig();
    };
    const handleMouseExit = () => {
        // we want to try and apply the signature after they leave the signature box
        setIsDrawing(false);
        addSig();
    };
    const handleMouseEnter = () => {
        if (stageWidth !== origWidth) {
            setOrigWidth(stageWidth);
        }
    };
    const handleTouchDown = (e) => {
        setIsDrawing(true);
        if (stageWidth !== origWidth) {
            setOrigWidth(stageWidth);
        }
        const pos = e.currentTarget.getStage()?.getPointerPosition();
        if (lines)
            setLines([...lines, { points: [pos?.x, pos?.y] }]);
    };
    const handleTouchMove = (e) => {
        // no drawing - skipping
        if (!isDrawing) {
            return;
        }
        e.evt.preventDefault();
        const point = e.currentTarget.getStage()?.getPointerPosition();
        const lastLine = lines?.[lines.length - 1];
        // add point
        if (lastLine)
            lastLine.points = lastLine.points.concat([point?.x, point?.y]);
        // replace last
        lines?.splice(lines.length - 1, 1, lastLine);
        setLines(lines?.concat());
    };
    const handleTouchEnd = () => {
        setIsDrawing(false);
        addSig();
    };
    return (React.createElement(SigStage, { ref: wrapperRef },
        React.createElement(Stage, { width: stageWidth, height: stageHeight, scaleX: stageScale, onTouchStart: handleTouchDown, onTouchMove: handleTouchMove, onTouchEnd: handleTouchEnd, onMouseEnter: handleMouseEnter, onMouseDown: handleMouseDown, onMouseMove: handleMouseMove, onMouseUp: handleMouseUp, onMouseLeave: handleMouseExit },
            React.createElement(Layer, { ref: signatureBox }, lines?.map((line, i) => (React.createElement(Line, { key: i, points: line.points, stroke: colorBrandRhumbixBlack, strokeWidth: signatureStyles.strokeWidth, tension: signatureStyles.lineTension, lineCap: "round", globalCompositeOperation: "source-over" })))))));
};
export default DrawToSign;
